export default __webpack_public_path__ + "static/media/logistic-parcel.fccf8511.png";